import React, { useEffect, useState } from "react";
import FormContainer from "./FormContainer";
import {
  getPlayerSports,
  initiatePayment,
  avalibleSlotsAPI,
  withdrawalSlotsAPI,
  holdSlotAPI,
  holdEnrollmentSlotAPI,
  getPlayerSportsLatest,
  FetchEnrolledHoldSlotData,
  FetchEnrolleMentToken,
  validWaitListPlayerAPI,
  TeamSlotAPI,
  WaitListSlotHold,
  cancelPaymentAPI,
} from "../../API/player";
import { getGamePricing, getSetting } from "../../API/admin";
import { Authenticated, Profile } from "../../API/auth";
import { useLocation, useNavigate } from "react-router-dom"; // Import necessary hooks

import Loader from "../../views/admin/Common/Loader";
import Swal from "sweetalert2";

import ChangeTeamModal from "../modal/ChangeTeamModal";

import PaymentModal from "../modal/PaymentModal";
import { useSnackbar } from "notistack";

const Gameplan = () => {
  let navigate = useNavigate();
  const [sports, setSports] = useState([]);
  const [gamePricing, setGamePricing] = useState([]);
  const [amount, setAmount] = useState(0);
  const [visible, setVisible] = useState(false);
  const [visibleTeamChange, setVisibleTeamChange] = useState(false);
  const [disable, setDisable] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [paymentIntent, setPaymentIntent] = useState("");
  const [waitList, setWaitList] = useState(false);
  const [loaderStatus, setloaderStatus] = useState(false);
  const [slotIdValue, setslotIdValue] = useState(null);
  const [slotToken, settokenValue] = useState(null);
  const [profile, setProfile] = useState(null);
  const [alredyEnrolled, setAllreadyEnrolled] = useState(null);
  const [showChangeTeamModal, setShowChangeTeamModal] = useState(false);
  const [TeamChangeRender, setTeamChangeRender] = useState(false);
  const [TeamChange, setTeamchange] = useState(false);
  const [SelectedTeam, setselectedTeam] = useState(null);
  const [UserAllredyEnrolled, setUserAllredyEnrolled] = useState(null);
  const [TeamChangeSlotDone, setTeamChangeSlotDone] = useState(false);
  const [OnSubmitBtn, setOnSubmitBtn] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const location = useLocation();
  //  var waiListPlayer = false;
  var [waiListPlayer, setwaiListPlayer] = useState(false);
  const params = new URLSearchParams(location.search);
  const nameMapping = {
    tennis: "table_tenis",
    twok_run: "2k_run",
  };
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    var EnrollToken = urlParams.get("enroll_token");
    var WaitListToken = urlParams.get("token");
    var WaitListSlotID = urlParams.get("slot");

    let getEnrollToken = async () => {
      let res = await FetchEnrolleMentToken();
      console.log(res);
      if (res.token != EnrollToken) {
        Swal.fire({
          title: "Payment Session Expired",
          text: "Your payment session has timed out. Please start the checkout process again to complete your payment.",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          cancelButtonText: "close",
        }).then((result) => {
          console.log("1");
          let formData = {
            regularPayment: true,
          };
          cancelPaymentAPI(formData).finally((res) => {
            navigate("/select-sport");

            if (result.isConfirmed) {
              // window.location.href('/logout')
              navigate("/dashboard");
            } else if (result.isDismissed) {
              navigate("/dashboard");
            }
          });
        });
      }
    };
    let getWaitlistToken = async () => {
      let formData = {
        document_id: WaitListSlotID,
      };
      var slotAPI = await withdrawalSlotsAPI(formData);
      if (slotAPI.data.status) {
        if (slotAPI.data.data.token_expiry != WaitListToken) {
          Swal.fire({
            title: "Payment Session Expired",
            text: "Your payment session has timed out. Please start the checkout process again to complete your payment.",
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: true,
            cancelButtonText: "close",
          }).then((result) => {
            console.log("2");
            let formData = {
              regularPayment: true,
            };
            cancelPaymentAPI(formData).finally((res) => {
              navigate("/select-sport");

              if (result.isConfirmed) {
                // window.location.href('/logout')
                navigate("/dashboard");
              } else if (result.isDismissed) {
                navigate("/dashboard");
              }
            });
          });
        }
      }
    };
    const isWaitlist = urlParams.has("wl");
    if (!isWaitlist) {
      getEnrollToken();
    } else {
      getWaitlistToken();
    }
  }, [OnSubmitBtn]);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const selectedSports = [];
      params.forEach((value, key) => {
        if (key === "waitList") {
          console.log("waiting true");

          setWaitList(true);
        } else if (value === "true") {
          selectedSports.push(key);
        }
      });

      setSports(selectedSports);
    }
    let callAPI = async () => {
      let res = await Profile();
      if (res.status) {
        setProfile(res.data);
      }
    };
    // check if user is alreay enrolled in any game or not
    let callAPI2 = async () => {
      let res = await getPlayerSportsLatest();
      console.log(res.data.data.sports);
      if (res.data.status && res.data.data.sports.length > 0) {
        console.log("user is alredy enrolled in one of the game");
        setAllreadyEnrolled(true);
      } else {
        console.log(
          "user is alredy not enrolled in any of the game ask to change team"
        );
        setAllreadyEnrolled(false);
      }
      // check from the sport varaibel(from link) if playter is alredy entolled i that sport show swal and do not make anypymetn
    };

    callAPI();
    callAPI2();
    // shifting this code for  alredy enrolled swal
  }, []);
  useEffect(() => {
    console.log("use effetc callleeee");
    if (sports.length) {
      let callAPI2 = async () => {
        console.log("called function");

        let res = await getPlayerSportsLatest();
        console.log(res.data.data.sports);
        if (res.data.status && res.data.data.sports.length > 0) {
          let validSport =
            sports[0] === "tennis"
              ? "table_tenis"
              : sports[0] === "twok_run"
              ? "2k_run"
              : sports[0];
          console.log("valid", validSport);
          if (
            res.data.data.sports.includes(validSport) &&
            !res.data.data.withdrawan_sports.includes(validSport)
          ) {
            Swal.fire({
              title: "You are already enrolled",
              text: "You are already enrolled in the sport.",
              icon: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: true,
              cancelButtonText: "close",
            }).then((result) => {
              if (result.isConfirmed) {
                // window.location.href('/logout')
                navigate("/dashboard");
              } else if (result.isDismissed) {
                navigate("/dashboard");
              }
            });
          } else {
            console.log("Not enrolledin ", sports);
          }
        }
        // check from the sport varaibel(from link) if playter is alredy entolled i that sport show swal and do not make anypymetn
      };
      callAPI2();
    }
  }, [sports]);
  let waitLitManage = async () => {
    const urlParams = new URLSearchParams(location.search);
    const isWaitlist = urlParams.has("wl");
    var slotValue = urlParams.get("slot");
    var token = urlParams.get("token");
    var validWaitListUser = false;
    var finalTeamChange = false;
    var TeamSlotAlredy = false;
    console.log("slot id gameplan", slotValue);
    console.log("token id gameplan", token);

    setslotIdValue(slotValue);
    settokenValue(token);
    if (isWaitlist) {
      // check if the user is waitlist or not
      let validWaitListFormData = {
        sport: sports.includes("tennis")
          ? "table_tenis"
          : sports.includes("bowling")
          ? "bowling"
          : sports.includes("badminton")
          ? "badminton"
          : sports.includes("twok_run")
          ? "2k_run"
          : null,
      };

      let isPlayerWaitListValid = await validWaitListPlayerAPI(
        validWaitListFormData
      );
      console.log("isPlayerWaitListValid", isPlayerWaitListValid);
      if (isPlayerWaitListValid.data.valid) {
        validWaitListUser = true;
        if (alredyEnrolled == false) {
          var SlotForTeam = false;
          console.log("checking if selected team of player has slot ");
          // hitting slot API to check if bthe current selected team has slot or not\
          let formDataSlotAPI = {
            gender: true,
            team: profile.corporate_email,
          };
          let res = await avalibleSlotsAPI(formDataSlotAPI);
          if (res.status) {
            if (sports.includes("tennis")) {
              console.log("checking for tennis");
              SlotForTeam =
                res.data.TotalResult.table_tenis == 0 ? false : true;
            } else if (sports.includes("bowling")) {
              console.log("checking for bowling");

              SlotForTeam = res.data.TotalResult.bowling == 0 ? false : true;
            } else if (sports.includes("badminton")) {
              console.log("checking for badminton");

              SlotForTeam = res.data.TotalResult.badminton == 0 ? false : true;
            } else if (sports.includes("twok_run")) {
              console.log("checking for 2k run");

              SlotForTeam = res.data.TotalResult.twok_run == 0 ? false : true;
            }

            // if SlotForTeam is false then we need to show the team change modal
            if (SlotForTeam == false) {
              console.log("showing team changing modal");
              finalTeamChange = true;
              setTeamChangeRender(true);
              const urlParams = new URLSearchParams(location.search);
              const isWaitlist = urlParams.has("wl");
              var slotValue = urlParams.get("slot");
              let formTeamData = {
                document_id: slotValue,
              };
              let res = await WaitListSlotHold(formTeamData);
              console.log("Res", res);
              if (res.data.status) {
                setShowChangeTeamModal(true);
              } else {
                TeamSlotAlredy = true;
              }
            } else {
              console.log(
                "not showing team changing modal because his team  has alrady available slot"
              );
            }
          } else {
            console.lopg("Slot APi is not working");
          }
        } else {
          console.log("user is already enrolled so no team change option");
        }
      } else {
        setloaderStatus(false);
        Swal.fire({
          title: "Invalid request ",
          text: "You are not in the waitlist for this game.",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          cancelButtonText: "close",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.href('/logout')
            navigate("/dashboard");
          } else if (result.isDismissed) {
            navigate("/dashboard");
          }
        });
      }
    }
    //final setup checking slot
    if (isWaitlist && slotValue && validWaitListUser) {
      // Perform your actions here
      console.log("waitlist is true");
      console.log("Slot", slotValue);

      var enrolled = false;
      var withdrwlSlot = false;
      setloaderStatus(true);
      let formDataSlotAPI = {
        gender: true,
        team: profile.corporate_email,
      };
      let res = await avalibleSlotsAPI(formDataSlotAPI);
      let formData = {
        document_id: slotValue,
        teamStatus: false,
      };
      var slotAPI = await withdrawalSlotsAPI(formData);
      console.log("Slot APi tokenm res Gameplan");
      console.log(slotAPI.data.data.token_expiry);

      console.log("token id");
      console.log(token);
      console.log(slotAPI.data.data.token_expiry == token);

      if (res.status && slotAPI.data.status) {
        setloaderStatus(false);
        if (sports.includes("tennis")) {
          enrolled = res.data.TotalResult.table_tenis == 0 ? false : true;
        } else if (sports.includes("bowling")) {
          enrolled = res.data.TotalResult.bowling == 0 ? false : true;
        } else if (sports.includes("badminton")) {
          enrolled = res.data.TotalResult.badminton == 0 ? false : true;
        } else if (sports.includes("twok_run")) {
          enrolled = res.data.TotalResult.twok_run == 0 ? false : true;
        }
        console.log(" TeamChangeRender", TeamChangeRender);
        if (finalTeamChange == true) {
          console.log("enrolled true");
          enrolled = true;
          withdrwlSlot = true;
        }
        console.log("test enrolled", enrolled);
        // ocupie the slot
        if (
          slotAPI.data.data.occupied_by == null ||
          slotAPI.data.data.occupied_by == undefined
        ) {
          if (finalTeamChange) {
            formData.teamStatus = true;
          }
          let updateSlot = await holdSlotAPI(formData);
          if (updateSlot.data.status) {
            console.log("user can register");
            withdrwlSlot = true;
          } else {
            setloaderStatus(false);
            Swal.fire({
              title: "Some error occured ",
              text: "Something went wrong",
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: true,
              cancelButtonText: "close",
            }).then((result) => {
              if (result.isConfirmed) {
                // window.location.href('/logout')
                navigate("/dashboard");
              } else if (result.isDismissed) {
                navigate("/dashboard");
              }
            });
          }
        } else if (
          slotAPI.data.data.occupied_by.toString() ===
            slotAPI.data.LoginUser.toString() &&
          slotAPI.data.data.token_expiry == token
        ) {
          setTeamChangeSlotDone(true);
          console.log("Checiinf witdh slot");
          withdrwlSlot = true;
        }
      }
      // check with time also the sessiojn should not be over

      console.log("Enrolled final if", enrolled);
      console.log("withdrwlSlot final if", withdrwlSlot);

      if (enrolled && withdrwlSlot) {
        // let formData = {
        //   "document_id": slotValue,
        //   "status": "false"
        // }
        // console.log()
        // if (slotAPI.data.data.occupied_by== null || slotAPI.data.data.occupied_by == undefined) {
        //    let updateSlot = await holdSlotAPI(formData);
        //    if (updateSlot.data.status) {
        //      console.log("user can register")
        //      return true
        //    }else {
        //      setIsLoading(false);

        //      Swal.fire({
        //        title: "Some error occured ",
        //        text: "Something went wrong",
        //        icon: "error",
        //        confirmButtonColor: "#3085d6",
        //        confirmButtonText: "Logout",
        //        allowOutsideClick: false,
        //        allowEscapeKey: false

        //      }).then((result) => {
        //        if (result.isConfirmed) {
        //            // window.location.href('/logout')
        //            navigate('/logout')
        //        }
        //    });
        //    }

        // }
        if (finalTeamChange && TeamSlotAlredy == false) {
          return [
            {
              status: true,
              paymentModalShow: false,
            },
          ];
        } else if (TeamSlotAlredy) {
          console.log("alredy here ");
          return [
            {
              status: true,
              paymentModalShow: true,
            },
          ];
        } else {
          return true;
        }
      } else {
        Swal.fire({
          title: "Slots are not available",
          text: "We are sorry slots are booked again , thank you for followig the email , we will inform you again if any slot gets avialable.",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          cancelButtonText: "close",
        }).then((result) => {
          if (result.isConfirmed) {
            // window.location.href('/logout')
            navigate("/dashboard");
          } else if (result.isDismissed) {
            navigate("/dashboard");
          }
        });
        return false;
      }
    } else {
      console.log("user can  not register");

      setloaderStatus(false);
      return false;
    }
  };

  let TournamentRegistration = async () => {
    setloaderStatus(true);
    let res = await getSetting();

    if (res.status) {
      setloaderStatus(false);

      // Check if any entry with name 'tournament_register' has a value of 'false'
      let registrationOpen = res.data.some(
        (entry) =>
          entry.name === "tournament_register" && entry.value === "true"
      );

      return registrationOpen;
    } else {
      setloaderStatus(false);
      return false;
    }
  };

  let HandelSubmit = async () => {
    let EnableRegister = await TournamentRegistration();
    console.log(EnableRegister);
    if (EnableRegister) {
      const urlParams = new URLSearchParams(location.search);
      var EnrollToken = urlParams.get("enroll_token");
      var WaitListToken = urlParams.get("token");
      var WaitListSlotID = urlParams.get("slot");
      let formData = {
        document_id: WaitListSlotID,
      };
      setloaderStatus(true);

      var slotAPI = await withdrawalSlotsAPI(formData);
      if (slotAPI.data.status) {
        if (slotAPI.data.data.token_expiry != WaitListToken) {
          setloaderStatus(false);

          Swal.fire({
            title: "Payment Session Expired",
            text: "Your payment session has timed out. Please start the checkout process again to complete your payment.",
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: true,
            cancelButtonText: "close",
          }).then((result) => {
            console.log("3");
            let formData = {
              regularPayment: true,
            };
            cancelPaymentAPI(formData).finally((res) => {
              navigate("/select-sport");

              if (result.isConfirmed) {
                // window.location.href('/logout')
                navigate("/dashboard");
              } else if (result.isDismissed) {
                navigate("/dashboard");
              }
            });
          });
        }
      }
      console.log("Lodaer being on");
      let result = await waitLitManage();
      console.log(" result", result);
      // console.log(' result', result[0].paymentModalShow)

      if (result.length && result[0].status) {
        console.log("herte");
        setwaiListPlayer(true);
        //  setloaderStatus(false)

        if (result.length && result[0].paymentModalShow == false) {
          setVisible(false);
          setloaderStatus(false);
        }
        if (result.length && result[0].paymentModalShow) {
          console.log("here in 511");
          setVisible(true);
          setloaderStatus(false);
        }
      } else if (result == true) {
        console.log("player can register");

        // waiListPlayer = true;
        setwaiListPlayer(true);
        setVisible(!visible);
        setloaderStatus(false);
      } else {
        console.log("player can not register");
        // if player is from waitlist hide the payment modal
        const urlParams = new URLSearchParams(location.search);
        const isWaitlist = urlParams.has("wl");
        if (isWaitlist) {
          return false;
        } else {
          console.log("hold slot can start here");
          setloaderStatus(true);

          let response = await SlotHold(EnrollToken);
          if (response) {
            console.log("slot is hold showing payment");
            setVisible(!visible);
            setloaderStatus(false);
          } else {
            setloaderStatus(false);
            Swal.fire({
              title: "Payment Session Expired",
              text: "Your payment session has timed out. Please start the checkout process again to complete your payment.",
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: true,
              cancelButtonText: "close",
            }).then((result) => {
              console.log("4");
              let formData = {
                regularPayment: true,
              };
              cancelPaymentAPI(formData).finally((res) => {
                navigate("/select-sport");

                if (result.isConfirmed) {
                  // window.location.href('/logout')
                  navigate("/dashboard");
                } else if (result.isDismissed) {
                  navigate("/dashboard");
                }
              });
            });
          }
        }
      }
    } else {
      Swal.fire({
        title: "Tournament registration are closed",
        text: "You are late , tournament registration are closed, try again next time",
        icon: "error",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
        cancelButtonText: "close",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // window.location.href('/logout')
          navigate("/dashboard");
        } else if (result.isDismissed) {
          navigate("/dashboard");
        }
      });
    }
  };

  let SlotHold = async (EnrollToken) => {
    try {
      var SlotForTeam = {
        badminton: null,
        table_tenis: null,
        bowling: null,
        twok_run: null,
      };
      console.log("checking if selected team of player has slot ");
      // hitting slot API to check if bthe current selected team has slot or not\
      let formDataSlotAPI = {
        gender: true,
        team: profile.corporate_email,
      };
      let alreadyHold1 = await FetchEnrolledHoldSlotData();
      console.log("allready1", alreadyHold1);
      if (alreadyHold1.status && alreadyHold1.totalRecords) {
        console.log("slot is already hold");
        return true;
      } else {
        let res = await avalibleSlotsAPI(formDataSlotAPI);
        if (res.status) {
          console.log("Slot APi hit");
          console.log(res.data.TotalResult);
          console.log(sports);

          if (sports.includes("tennis")) {
            console.log("checking for tennis");
            SlotForTeam.table_tenis =
              res.data.TotalResult.table_tenis == 0 ? false : true;
          }
          if (sports.includes("bowling")) {
            console.log("checking for bowling");

            SlotForTeam.bowling =
              res.data.TotalResult.bowling == 0 ? false : true;
          }
          if (sports.includes("badminton")) {
            console.log("checking for badminton");

            SlotForTeam.badminton =
              res.data.TotalResult.badminton == 0 ? false : true;
          }
          if (sports.includes("twok_run")) {
            console.log("checking for 2k run");

            SlotForTeam.twok_run =
              res.data.TotalResult.twok_run == 0 ? false : true;
          }
          console.log("SlotForTeam", SlotForTeam);
          // if SlotForTeam is false then we need to show the team change modal
          function findNullKeys(slotObject) {
            const nullKeys = [];
            const keyMapping = {
              badminton: "badminton",
              table_tenis: "table tennis",
              bowling: "bowling",
              twok_run: "2k run",
            };

            for (const key in slotObject) {
              if (slotObject[key] === false) {
                nullKeys.push(keyMapping[key]);
              }
            }

            return nullKeys.length > 0 ? nullKeys.join(", ") : "";
          }
          const keysWithNullValues = findNullKeys(SlotForTeam);
          if (keysWithNullValues) {
            Swal.fire({
              title: "Slots are not available.",
              text: `while you were proceeding ,slots for following games  ${keysWithNullValues} are unavailable.`,
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: true,
              cancelButtonText: "close",
            }).then((result) => {
              if (result.isConfirmed) {
                // window.location.href('/logout')
                navigate("/dashboard");
              } else if (result.isDismissed) {
                navigate("/dashboard");
              }
            });
          }
        } else {
          console.lopg("Slot APi is not working");
          Swal.fire({
            title: "Some error occuered while fetching slots ",
            text: `we are having trouble in fetching slots currently, please try again later`,
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: true,
            cancelButtonText: "close",
          }).then((result) => {
            if (result.isConfirmed) {
              // window.location.href('/logout')
              navigate("/dashboard");
            } else if (result.isDismissed) {
              navigate("/dashboard");
            }
          });
        }
        console.log("SlotForTeam", SlotForTeam);
        let SportsToHold = [];
        if (Object.values(SlotForTeam).some((value) => value === true)) {
          console.log("holding slot");
          for (const [key, value] of Object.entries(SlotForTeam)) {
            if (value === true) {
              SportsToHold.push(key);
            }
          }
          let formData = {
            sports: SportsToHold,
            inc: 0,
            dec: 1,
            token: EnrollToken,
          };
          console.log("Hitting slot API");
          let alreadyHold = await FetchEnrolledHoldSlotData();
          console.log("allready", alreadyHold);
          if (alreadyHold.status && alreadyHold.totalRecords) {
            console.log("slot is already hold");
            return true;
          } else {
            let res = await holdEnrollmentSlotAPI(formData);
            console.log("ress", res);

            if (res.data.status) {
              console.log("slot is hold");
              return true;
            } else {
              console.log("hold slor APi failed");
              return false;
            }
          }
        } else {
          console.log("no slot is choosen");
          return false;
        }
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };
  useEffect(() => {
    if (sports.length > 0 && gamePricing.length > 0) {
      const fetchData = () => {
        const matchedData = sports
          .map((item) => {
            const mappedName = nameMapping[item] || item;
            return gamePricing.find((data) => data.name === mappedName);
          })
          .filter(Boolean); // Filters out any undefined results
        return matchedData;
      };
      let result = fetchData();
      console.log(result);
      var TotalAmount = 0;
      result.map((data, index) => {
        TotalAmount += data.price;
      });
      setAmount(TotalAmount);
    }
  }, [sports, gamePricing]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (amount == 0) {
      setDisable(true);
    } else {
      setDisable(false);
    }
    if (amount > 0 && token) {
      const callAPI = async () => {
        console.log("Amountpay", amount);

        let res = await initiatePayment({ amount: amount });

        try {
          if (res.status) {
            setClientSecret(res.data.data.client_secret);
            setPaymentIntent(res.data.data.id);
          } else {
            enqueueSnackbar("unable to initiate payment", {
              variant: "error",
              action: (key) => (
                <button
                  className="toast_close_btn"
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            });
          }
        } catch (error) {
          enqueueSnackbar("unable to initiate payment", {
            variant: "error",
            action: (key) => (
              <button
                className="toast_close_btn"
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key);
                }}
              >
                X
              </button>
            ),
          });
        }
      };
      callAPI();
    }
  }, [amount]);

  useEffect(() => {
    let CallAPI = async () => {
      setloaderStatus(true);
      let res = await getGamePricing();
      setloaderStatus(false);

      console.log(res);
      if (res.status) {
        setGamePricing(res.data);
      } else {
      }
    };
    if (sports.length > 0) {
      CallAPI();
    }
  }, [sports]);
  const handleClick = () => {
    setVisible(!visible);
  };

  const getPriceForSport = (sport) => {
    const mappedName = nameMapping[sport] || sport;
    const game = gamePricing.find((data) => data.name === mappedName);
    return game ? game.price : null;
  };
  const onTeamChangeSubmit = async (value, team) => {
    console.log("team selection ", value);
    if (value) {
      console.log("changing team state");
      setTeamchange(true);
      setselectedTeam(team);
      setwaiListPlayer(true);
      const urlParams = new URLSearchParams(location.search);
      var WaitListToken = urlParams.get("token");
      var WaitListSlotID = urlParams.get("slot");
      let checkSlotHoldAlreadyFormData = {
        document_id: WaitListSlotID,
      };
      setloaderStatus(true);

      let checkSlotHoldAlready = await WaitListSlotHold(
        checkSlotHoldAlreadyFormData
      );
      console.log("checkSlotHoldAlready", checkSlotHoldAlready);
      if (checkSlotHoldAlready.status) {
        let formData = {
          team: team,
          sport: sports,
          action: -1,
        };
        let res = await TeamSlotAPI(formData);
        console.log(res);
        if (res.status) {
          setloaderStatus(false);
          setVisible(!visible);
        } else {
          Swal.fire({
            title: "Somthing went wrong",
            text: "Your session to book the slot is expired. try again",
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: true,
            cancelButtonText: "close",
          }).then((result) => {
            if (result.isConfirmed) {
              // window.location.href('/logout')
              navigate("/dashboard");
            } else if (result.isDismissed) {
              navigate("/dashboard");
            }
          });
        }
      } else {
        setloaderStatus(false);
        setVisible(!visible);
      }

      console.log("visible", !visible);
    } else {
      Swal.fire({
        title: "Somthing went wrong",
        text: "Unable to change team now",
        icon: "error",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
        cancelButtonText: "close",
      }).then((result) => {
        if (result.isConfirmed) {
          // window.location.href('/logout')
          navigate("/dashboard");
        } else if (result.isDismissed) {
          navigate("/dashboard");
        }
      });
    }
  };
  return (
    <>
      {loaderStatus ? <Loader /> : null}
      <FormContainer classname="col-md-10">
        <PaymentModal
          waitListPlayer={waiListPlayer}
          visible={visible}
          onClose={() => setVisible(false)}
          clientSecret={clientSecret}
          paymentIntent={paymentIntent}
          sports={sports}
          waitList={waitList}
          slotID={slotIdValue}
          tokenValue={slotToken}
          TeamChange={TeamChange}
          SelectedTeam={SelectedTeam}
        />
        {TeamChangeRender ? (
          <ChangeTeamModal
            waitListPlayer={waiListPlayer}
            visible={showChangeTeamModal}
            onClose={() => setShowChangeTeamModal(false)}
            sport={sports}
            onSubmitSuccess={onTeamChangeSubmit}
            slotIdValue={slotIdValue}
          />
        ) : null}
        <div
          class="card d-flex justify-content-center mt-5 mb-3"
          style={{ width: 250, borderRadius: 10, margin: "auto" }}
        >
          <div
            className="card text-center"
            style={{
              borderRadius: 15,
              boxShadow: "0 4px 18px rgba(0,0,0,0.1)",
              maxWidth: 300,
            }}
          >
            <div
              className="card-header  text-white w-100"
              style={{
                borderTopLeftRadius: 15,
                borderTopRightRadius: 15,
                backgroundColor: "#0D3C6D",
                paddingTop: 40,
                paddingBottom: 35,
                borderRadius: "10px 10px 45% 45%",
                backgroundColor: "rgb(13, 60, 109)",
              }}
            >
              <h5>Games Plan</h5>
            </div>
            <div className="card-body">
              <h2
                className="text-danger font-weight-bold"
                style={{ color: "##0D3C6D" }}
              >
                ${amount}
              </h2>
              {/* <ul className="list-unstyled">
                          {sports.includes('badminton') && (
                            <li className="d-flex justify-content-between">
                              <span>
                                <i className="text-success">✔</i> Badminton
                              </span>
                              <span>$80</span>
                            </li>
                          )}
                          {sports.includes('tennis') && (
                            <li className="d-flex justify-content-between">
                              <span>
                                <i className="text-success">✔</i> Table Tennis
                              </span>
                              <span>$80</span>
                            </li>
                          )}
                          {sports.includes('bowling') && (
                            <li className="d-flex justify-content-between">
                              <span>
                                <i className="text-success">✔</i> Bowling
                              </span>
                              <span>$80</span>
                            </li>
                          )}
                          {sports.includes('twok_run') && (
                            <li className="d-flex justify-content-between">
                              <span>
                                <i className="text-success">✔</i> 2k Run
                              </span>
                              <span>$80</span>
                            </li>
                          )}
                          </ul> */}

              <ul className="list-unstyled">
                {sports.includes("badminton") && (
                  <li className="d-flex justify-content-between">
                    <span>
                      <i className="text-success">✔</i> Badminton
                    </span>
                    {getPriceForSport("badminton") && (
                      <span>
                        <s>$80</s> ${getPriceForSport("badminton")}
                      </span>
                    )}
                  </li>
                )}
                {sports.includes("tennis") && (
                  <li className="d-flex justify-content-between">
                    <span>
                      <i className="text-success">✔</i> Table Tennis
                    </span>
                    {getPriceForSport("tennis") && (
                      <span>
                        <s>$80</s> ${getPriceForSport("tennis")}
                      </span>
                    )}
                  </li>
                )}
                {sports.includes("bowling") && (
                  <li className="d-flex justify-content-between">
                    <span>
                      <i className="text-success">✔</i> Bowling
                    </span>
                    <span> ${getPriceForSport("bowling")}</span>
                  </li>
                )}
                {sports.includes("twok_run") && (
                  <li className="d-flex justify-content-between">
                    <span>
                      <i className="text-success">✔</i> 2k Run
                    </span>
                    <span> ${getPriceForSport("twok_run")}</span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        <center>
          <button
            className="btn btn-light w-80 border-0 px-3 py-3 fs-5 fw-bold rounded-3 submit-button text-white"
            disabled={disable}
            onClick={() => HandelSubmit()}
          >
            {" "}
            Submit
          </button>
        </center>
      </FormContainer>
    </>
  );
};
export default Gameplan;
